module.exports = __webpack_public_path__ + "img/tu_schedule_training.d556227c.svg";